import * as React from "react";
import { InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { Search } from "@material-ui/icons";

export interface SearchFieldProps {
  value: string;
  onSearch: (query: string) => void;
}

const useStyles = makeStyles({
  searchField: {
    width: 20,
    height: 20,
  },
  textField: {
    width: 250,
    margin: "10px 0px",
  },
});

export const SearchField = ({ value, onSearch }: SearchFieldProps) => {
  const classes = useStyles();

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(event.target.value as string);
  };

  return (
    <div>
      <TextField
        placeholder="Search for teammates"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search className={classes.searchField} />
            </InputAdornment>
          ),
          disableUnderline: true,
        }}
        value={value}
        onChange={handleSearch}
        classes={{ root: classes.textField }}
        variant="standard"
      />
    </div>
  );
};
